import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import NotificationApi from '../notification-base';
import Content from './content';
var defaultPlacement = 'bottomRight';
var defaultDuration = 0;
var defaultOffset = '40px';
var defaultStyle = {};
var defaultClosable = true;
var defaultShowIcon = false;
var defaultSuffixCls = 'notice';
var defaultType = 'primary';
var defaultTitle = '系统提示'; // 'notice'

var notificationElements = {};
var notificationKey = 1;

var getNotificationProps = function getNotificationProps(args) {
  var _args$placement = args.placement,
      placement = _args$placement === void 0 ? defaultPlacement : _args$placement,
      _args$duration = args.duration,
      duration = _args$duration === void 0 ? defaultDuration : _args$duration,
      key = args.key,
      className = args.className,
      _args$style = args.style,
      style = _args$style === void 0 ? defaultStyle : _args$style,
      _args$type = args.type,
      type = _args$type === void 0 ? defaultType : _args$type,
      onClose = args.onClose,
      _args$closable = args.closable,
      closable = _args$closable === void 0 ? defaultClosable : _args$closable,
      _args$title = args.title,
      title = _args$title === void 0 ? defaultTitle : _args$title,
      footer = args.footer,
      content = args.content,
      icon = args.icon,
      closeNode = args.closeNode,
      _args$showIcon = args.showIcon,
      showIcon = _args$showIcon === void 0 ? defaultShowIcon : _args$showIcon;

  var contentClose = function contentClose() {
    onClose && onClose(key);
    NotificationApi.destroy(key);
  };

  var contentProps = {
    icon: icon,
    closeNode: closeNode,
    type: type,
    title: title,
    footer: footer,
    content: content,
    closable: closable,
    showIcon: showIcon,
    suffixCls: defaultSuffixCls,
    contentClose: contentClose
  };
  return {
    duration: duration,
    placement: placement,
    key: key,
    className: className,
    style: style,
    content: /*#__PURE__*/React.createElement(Content, _extends({}, contentProps)),
    type: type,
    closable: false,
    onClose: onClose,
    suffixCls: defaultSuffixCls
  };
};

var setStyleByPlacement = function setStyleByPlacement(placement, el) {
  switch (placement) {
    case 'topLeft':
      el.style.left = defaultOffset;
      el.style.top = defaultOffset;
      el.style.bottom = 'auto';
      break;

    case 'topRight':
      el.style.right = defaultOffset;
      el.style.top = defaultOffset;
      el.style.bottom = 'auto';
      break;

    case 'bottomLeft':
      el.style.left = defaultOffset;
      el.style.top = 'auto';
      el.style.bottom = defaultOffset;
      break;

    default:
      el.style.right = defaultOffset;
      el.style.top = 'auto';
      el.style.bottom = defaultOffset;
      break;
  }
};

var getNotificationHTMLElement = function getNotificationHTMLElement(placement) {
  var prefixCls = 'kd';
  var suffix = "".concat(prefixCls, "-notice");
  var htmlElement = document.querySelector("#".concat(suffix, "-").concat(placement));

  if (!htmlElement) {
    htmlElement = document.createElement('div');
    htmlElement.id = "".concat(suffix, "-").concat(placement);
    htmlElement.className = "".concat(suffix, "-box-").concat(placement);
    setStyleByPlacement(placement, htmlElement);
    document.body.appendChild(htmlElement);
  }

  return htmlElement;
};

var notice = function notice(args) {
  var key = args.key || notificationKey++;
  var props = getNotificationProps(_extends(_extends({}, args), {
    key: key
  }));
  var placement = props.placement;
  var el;

  if (notificationElements[placement]) {
    el = notificationElements[placement];
  } else {
    el = getNotificationHTMLElement(placement);
  }

  NotificationApi.add(props, el);
};

var Notification = {
  open: notice,
  info: function info(args) {
    return notice(_extends(_extends({}, args), {
      type: 'info'
    }));
  },
  primary: function primary(args) {
    return notice(_extends(_extends({}, args), {
      type: 'primary'
    }));
  },
  destroy: function destroy(key) {
    NotificationApi.destroy(key);
  }
};
export default Notification;